import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { FormGroup, FormControl, Validators, FormArrayName } from '@angular/forms';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
@Component({
  selector: 'app-demoregistration',
  templateUrl: './demoregistration.component.html',
  styleUrls: ['./demoregistration.component.css']
})
export class DemoregistrationComponent implements OnInit {


  constructor(private toastr: ToastrService, private appService: AppdataService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal
    , private confirmationDialogService: ConfirmationDialogService,
    private productFindService: NgbModal) { }

  //Save Validation
  submitted: boolean;
  successfully: boolean;

  show: boolean;

  countryColl:any=[];
  stateColl:any=[];


  demoregform = new FormGroup({
    companyname: new FormControl('',Validators.required),
    phone: new FormControl(''),
    email: new FormControl(''),
    city: new FormControl(''),
    state: new FormControl(''),
    passwd: new FormControl(''),
  });


  @Input() companyname: any = '';
  @Input() phone: any = '';
  @Input() email: any = '';
  @Input() city: any = '';
  @Input() state: String = '';
  @Input() passwd: String = '';


  @Output() emitData = new EventEmitter();

  ngOnInit() {

    this.fnCheckUserPririvilage();

    this.demoregform.reset();
    this.fnInitializeFormGroup();
    this.fngetCountries();
    this.fngetState();

  }

  fnCheckUserPririvilage() {

    // this.isallowanceaddmode = this.loginService.fnCheckUserRoleAction("Allowance", 'CREATE')

  }

  fnInitializeFormGroup() {
    this.demoregform.setValue({
      companyname: this.companyname,
      email: this.email,
      phone: this.phone,
      city: this.city,
      state: this.state,
      passwd: this.passwd,
    })

  }
  fngetCountries() {

    this.appService.getCountries().subscribe((res) => {
      this.countryColl = res.json();
      console.log(this.countryColl)

    })
  }

  fngetState() {

      var city =this.demoregform.get('city').value
   
      this.stateColl = []

    this.appService.getState(city).subscribe((res) => {
      this.stateColl = res.json();
  

    })
  }
  fnResetValidator() {

  }

  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.demoregform.valid) {
        //Check
        var data = {
          companyname: this.demoregform.get('companyname').value,
          email: this.demoregform.get('email').value,
          phone: this.demoregform.get('phone').value,
          city: this.demoregform.get('city').value,
          state: this.demoregform.get('state').value,
          passwd: this.demoregform.get('passwd').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),

        }

        this.fnInsertDemoCompanyReg(data);

        this.emitData.emit(data);
        this.activeModal.close(true);


      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }

  }


  //Insert
  fnInsertDemoCompanyReg(data) {

    this.appService.fnInsertCompanyRegistration(data).subscribe(
      (res) => {


        if (res.json().status === 200) {
          if (res.json().result != "") {


            this.toastr.success('', "The new Company Registration has been added successfully.Insert Successfully");


            this.emitData.emit(data);
            this.activeModal.close(true);
          }
        }
        else {

          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  fnShowpassword(event) {
 
    this.show = !this.show;
  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
